export class addParentChildModel {
    Salutation:string;
    FirstName:string;
    LastName:string;
    PhoneNumber:string;
    EmailAddress:string;
    IsSMSUser:boolean;
    childfirstname:string;
    childlastname:string;
    ChildGenderId:number;
}
export class motherChildModel {
    Salutation:string;
    FirstName:string;
    LastName:string;
    PhoneNumber:string;
    EmailAddress:string;
    IsSMSUser:boolean;
    childfirstname:string;
    childlastname:string;
    ChildGenderId:number;
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/parentchild/addparent/addparentchild.model.ts